<template>

  <div>
    <el-table :data="devices">
      <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="name"></el-table-column>
      <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid"></el-table-column>
      <el-table-column :label="$t('chan_pin_ming_chen')" align="center" prop="productName"></el-table-column>
      <el-table-column :label="$t('cao_zuo')" align="center">
        <template slot-scope="scope">
          <span @click="handleUnBind(scope.row, scope.$index)" class="device_delete">{{$t('jie_bang')}}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      class="pagination"
      :current-page="pagination.curPage"
      :page-size="pagination.limit"
      layout="total, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
  </div>

</template>

<script>
  import {payDeviceUnion, payDeviceList, payDeviceUnbind} from '@/api/delivery/pay/set'

  export default {
    name: '',
    components: {},
    mounted: function () {
    },
    data: function () {
      return {
        devices: [],
        pagination: {
          uuid: '',
          start: 0,
          curPage: 1,
          limit: 10,
          total: 0,
        },
      }
    },
    methods: {
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        payDeviceList(this.pagination).then(res => {
          this.devices = res.data || []
        })
      },
      handleUnBind(val, idx) {

        this.$confirm(this.$t('shi_fou_jie_bang_she_bei'), this.$t('ti_shi'), {
          confirmButtonText: this.$t('que_ding'),
          cancelButtonText: this.$t('qu_xiao'),
          type: 'warning'
        }).then(() => {
          let vue = this
          payDeviceUnbind({uuid: this.pagination.uuid, deviceUuid: val.uuid}).then(res => {
            vue.devices.splice(idx, 1)
          })


        }).catch(() => {

        })

      },

      loadDevices(uuid) {
        let vue = this
        this.pagination.uuid = uuid
        payDeviceUnion(this.pagination).then(res => {
          vue.devices = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .device_delete{
    cursor: pointer;
    color: $f_color;
  }
</style>
